import _sfc_main from "./SelectPC.vue2.mjs";
/* empty css               */
import normalizeComponent from "../../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { directives: [{ name: "click-outside", rawName: "v-click-outside", value: _setup.handleClickOutside, expression: "handleClickOutside" }], ref: "selectContainerRef", class: ["select-container", _setup.themeClass] }, [_c("div", { class: ["select-content", { disabled: _vm.disabled }], on: { "click": _setup.handleClickSelect } }, [_c("span", { staticClass: "select-text", style: _setup.props.customSelectContentStyle }, [_vm._v(" " + _vm._s(_setup.selectedLabel || _setup.selectedValue) + " ")]), _c(_setup.SvgIcon, { class: ["arrow-icon", { reverse: _setup.showSelectDropdown }], attrs: { "icon": _setup.ArrowStrokeSelectDownIcon } })], 1), _c("Transition", { attrs: { "name": "select-fade" } }, [_c("div", { directives: [{ name: "show", rawName: "v-show", value: _setup.showSelectDropdown, expression: "showSelectDropdown" }], ref: "selectDropDownRef", class: ["select-dropdown-container", _setup.dropDirection], style: _setup.dropDownStyle }, [_vm._t("default")], 2)])], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "449c26d8"
);
const SelectPC = __component__.exports;
export {
  SelectPC as default
};
